export default "__VITE_ASSET__4518138d__"